import { useSelector } from "react-redux";
import { AppState } from "../../appSlice";
import { RootState } from "../../store";
import Progress from "./Progress"
import NoPercentProgress from "./NoPercentProgress";

export type AppProgressProps = {
    showCardVariants?: boolean,
    showCards?: boolean,
    showJobs?: boolean,
    showCategories?: boolean,
    showProducts?: boolean,
    showCollection?: boolean,
    showArtists?: boolean
}

export function AppProgress(props: AppProgressProps) {
    const {
        jobProgress,
        artistProgress,
        categoryProgress,
        rawCardsProgress,
        variantsProgress,
        productsProgress,

        jobsComplete,
        cardsComplete,
        artistsComplete,
        variantsComplete,
        categoriesComplete,
        productsComplete
    } = useSelector<RootState, AppState>(x => x.app);

    return (
        <div className="px-4">
            <div className="p-4 border border-gray-200 rounded-md shadow-md max-w-sm space-y-4 m-auto mt-20">
                {
                    props.showCardVariants &&
                    <NoPercentProgress title='Downloading Card Variants...' progress={variantsProgress} isComplete={variantsComplete} />
                }
                {
                    props.showCards &&
                    <NoPercentProgress title='Downloading Cards...' progress={rawCardsProgress} isComplete={cardsComplete} />
                }
                {
                    props.showJobs &&
                    <NoPercentProgress title='Downloading Jobs...' progress={jobProgress} isComplete={jobsComplete} />
                }
                {
                    props.showCategories &&
                    <NoPercentProgress title='Downloading Categories...' progress={categoryProgress} isComplete={categoriesComplete} />
                }
                {
                    props.showProducts &&
                    <NoPercentProgress title='Downloading Products...' progress={productsProgress} isComplete={productsComplete} />
                }
                {
                    props.showArtists &&
                    <NoPercentProgress title='Downloading Artists...' progress={artistProgress} isComplete={artistsComplete} />
                }
            </div>
        </div>
    )
}